import * as React from 'react';

import { Flex, flameTheme } from '@lightspeed/flame/Core';
import { Heading4, Text, TextLink } from '@lightspeed/flame/Text';

import { useGetAppDownloadUrl } from 'pages/views/devices/hooks/use-get-app-download-url';
import { URL } from 'pages/views/devices/utils/help-urls';
import { APP_NAME, getDetectedPlatform } from 'pages/views/devices/utils/helper';

import { PLATFORMS } from '../types';

import { Hub } from './Hub';

const ManageHub: React.FunctionComponent = () => {
  const { platform } = getDetectedPlatform();
  const { appDownloadLinks } = useGetAppDownloadUrl();
  const { colors } = flameTheme;

  return (
    <Flex width="100%">
      <Flex flexDirection="column" maxWidth="240px" flex="0 1 auto" minWidth="225px" mr={7}>
        <Heading4 mb={1} color={colors['gray-850']}>
          {APP_NAME}
        </Heading4>
        <Text mb={1}>
          {APP_NAME} enables you to set up and manage your printers and Customer Facing Display all
          in one place.
        </Text>
        <TextLink
          color={colors['blue-500']}
          fontWeight="bold"
          href={URL.ABOUT_HUB}
          target="_blank"
          mb={1}
          width="fit-content"
        >
          Learn more
        </TextLink>
        <TextLink
          href={appDownloadLinks?.[platform as PLATFORMS]}
          download
          fontWeight="bold"
          width="fit-content"
        >
          Download latest version
        </TextLink>
      </Flex>
      <Hub />
    </Flex>
  );
};

export { ManageHub };
